import { featuresData } from "@/mocks/homeData";

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">平台优势</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">选择天美麻花星空影视的五大理由</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((feature) => (
            <article
              key={feature.title}
              className="bg-background-100 rounded-lg border border-background-200/50 p-5 md:p-6 text-center hover:border-primary-500/20 transition-all duration-300 cursor-default"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/20 text-primary-500 mx-auto mb-3 md:mb-4">
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </span>
              <h3 className="text-foreground-200 text-sm md:text-base font-medium mb-2">{feature.title}</h3>
              <p className="text-foreground-600 text-xs leading-relaxed">{feature.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}